<template>
  <div>
    <p v-if="!sent" class="page-header mb0">
      {{ $t('views.resetPassword.resetPassword') }}
      <span
        class="page-sub-header"
        v-text="
          resetKey
            ? $t('views.resetPassword.enterPassword')
            : $t('views.resetPassword.enterEmail')
        "
      ></span>
    </p>
    <div class="reset row">
      <div class="col s12" v-if="resetKey" key="key">
        <change-password
          :round="true"
          :reset-code="resetKey"
          theme="light"
        ></change-password>
      </div>

      <div v-if="!resetKey" class="col s12">
        <div v-if="!sent" key="requestReset">
          <s-text-input
            v-model="email"
            autocomplete="email"
            id="InputEmail"
            @keyup.enter="requestReset"
            type="email"
            :label="$t('generic.email')"
            :rounded="true"
          ></s-text-input>
          <flex-grid :force-row="true" class="button-container mt20">
            <s-button
              :small="true"
              :dark="true"
              :flat="true"
              class="underline"
              :to="{ name: 'start' }"
              >{{ $t('generic.cancel') }}</s-button
            >
            <s-button
              @click="requestReset"
              :disabled="!isRequestValid"
              :small="true"
              :loading="loading"
              color="blue"
              >{{ $t('views.resetPassword.reset') }}</s-button
            >
          </flex-grid>
          <div v-if="resetError" class="error center-text">
            {{ $t('views.resetPassword.sendError') }}
          </div>
        </div>
        <div v-else key="sent" class="center-text">
          <br />
          <br />
          {{ $t('views.resetPassword.emailAccountReset') }}
          <br />
          <br />
          {{ $t('views.resetPassword.clickLink') }}
          <flex-grid :force-row="true" class="button-container mt20">
            <s-button
              :small="true"
              :dark="true"
              :flat="true"
              class="underline"
              :to="{ name: 'start' }"
              >{{ $t('generic.back') }}</s-button
            >
          </flex-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from '@common/Services/AuthService';
import ChangePassword from '@common/Components/Auth/ChangePassword.vue';
import FlexGrid from '@common/Components/Grids/FlexGrid.vue';

export default {
  components: { ChangePassword, FlexGrid },
  props: {
    resetKey: String
  },
  data() {
    return {
      email: '',
      sent: false,
      loading: false,
      resetError: false
    };
  },
  mounted() {
    if (this.resetKey) {
      AuthService.verifyPasswordReset(this.resetKey);
    }
  },
  methods: {
    requestReset() {
      this.loading = true;
      this.resetError = false;
      AuthService.resetPassword(this.email)
        .then(() => {
          this.sent = true;
        })
        .catch(err => {
          console.log(err.message);
          this.resetError = true;
        })
        .finally(() => (this.loading = false));
    }
  },
  computed: {
    isRequestValid() {
      return this.email.length > 0;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

div {
  color: #000;
}
.fullscreen-center {
  font-size: 15px;
  flex-direction: column;
}
.reset {
  width: 100%;
  max-width: 400px;

  svg {
    max-width: 100%;
    fill: $symptoms-blue;
  }
}
.error {
  padding-top: 15px;
  color: #c55;
}
</style>
